// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

import InternalExpandableSection from '../../expandable-section/internal';
export type { InternalExpandableSectionProps } from '../../expandable-section/internal';
export { InternalExpandableSection };
